import { render } from "./ShahbetAttendance.vue?vue&type=template&id=f135480c&scoped=true"
import script from "./ShahbetAttendance.vue?vue&type=script&lang=js"
export * from "./ShahbetAttendance.vue?vue&type=script&lang=js"

import "./ShahbetAttendance.vue?vue&type=style&index=0&id=f135480c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f135480c"]])

export default __exports__